<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createSubscriptions()"        
        hidden
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Create Subscription</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-table
        responsive="sm"
        :fields="fields"
        :items="subscriptions"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_subscription')"
        :per-page="0"
      >
        <template #cell(expirationDateTime)="row">
          <b-badge :variant="getExpiryClass(row.item.expirationDateTime)">
            {{ formatExpiryDate(row.item.expirationDateTime) }}
          </b-badge>
        </template>

        <template #cell(manage)="row">
          <b-button
            variant="danger"
            pill
            size="sm"
            class="mr-50"
            @click="removeSubscription(row.item)"
          >
            Delete Subscription
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import VueGauge from 'vue-gauge';
import axios from 'axios';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";



export default {
  components: {
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "id", label: "Subscription ID" },
        { key: "applicationId", label: "Application ID" },
        { key: "expirationDateTime", label: "Expiry Date/Time" },
        { key: "manage", label: "Action"}
      ],
      access_token: null,
      subscriptions: [],
    };
  },
  mixins: [util],
  created() {
    this.fetchSubscriptions();
  },
  async mounted() {
  },
  methods: {
    ...mapActions({
      getSubscriptionsToken: "appData/getSubscriptionsToken",
      createSubscription: "appData/createSubscription",
      deleteSubscription: "appData/deleteSubscription",
    }),

    async fetchSubscriptions() {
      try {
        if (!this.access_token) {
          await this.getAccessToken();
        }
        const res = await axios.get('https://graph.microsoft.com/v1.0/subscriptions', {
          headers: {
            Authorization: `Bearer ${this.access_token}`
          }
        });
        this.subscriptions = res.data.value;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Token expired, refresh it
          await this.getAccessToken();
          this.fetchSubscriptions();
        } else {
          this.displayError(error);
        }
      }
    },
    
    async createSubscriptions() {      
      const res = await this.createSubscription();
      if (res.status === 200) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Subscribed Successfully",
              variant: "success",
              icon: "BellIcon",
            },
          },
          {
            position: "top-right",
          }
        );    
        this.fetchSubscriptions();
      }      
    },
    
    async removeSubscription(subscription) {
      try {
        const res = await this.deleteSubscription({
          subscription_id: subscription.id,
          access_token: this.access_token
        });
        if (res.status === 200) {
          this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Subscription Deleted",
              variant: "success",
              icon: "BellIcon",
            },
          },
          {
            position: "top-right",
          }
        );
          this.fetchSubscriptions();          
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async getAccessToken() {
      const access_token = await this.getSubscriptionsToken();
      this.access_token = access_token.data.access_token;
    },

    formatExpiryDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },    

    getExpiryClass(expirationDateTime) {
      const currentTime = new Date();
      const expiryTime = new Date(expirationDateTime);

      if (expiryTime > currentTime) {
        return 'info blink'; // Add your blink-primary CSS class
      } else {
        return 'danger blink'; // Add your blink-danger CSS class
      }
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
};
</script>

<style>
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  font-size: 16px;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
